<template>
    <div>
        <p>
            Your request for login code by mail has been received successfully. We have sent it to the following mailing address we have on file. You should receive the login code by mail in the next 15-20 days.
            Once you receive the login code please re-login on the online DMV Customer portal and you will be prompted to enter the login code. On successful validation of the login code you will be able to
            setup email and / or cell phone # on your record with RI DMV. 
        </p>

        <p>
            The login code is valid for 30 days. 
        </p>

        <h2>Mailing address on file</h2>

        <div class="user-address">
            <span>{{ contactInfo.mailingAddress.addressLine1 }} </span>
            <span>{{ contactInfo.mailingAddress.addressLine2 }}</span>  
            
            <span>{{contactInfo.mailingAddress.city }},
                {{ contactInfo.mailingAddress.addressType == 'Us Domestic'? 
                contactInfo.mailingAddress.state : 
                contactInfo.mailingAddress.province }}, 
                {{ contactInfo.mailingAddress.country }}
            </span>
            <span>
                {{ contactInfo.mailingAddress.addressType == 'Us Domestic' ?
                contactInfo.mailingAddress.zipPlus == '' ?  contactInfo.mailingAddress.zipCode :
                `${contactInfo.mailingAddress.zipCode} - ${contactInfo.mailingAddress.zipPlus}`
                : `${contactInfo.mailingAddress.internationalZipCode}`
                }}
            </span>
        </div>

        <BaseButtonGroup> 
            <button class="app-btn-primary" @click="handleRouting('close')">Close</button>       
        </BaseButtonGroup>
    </div>
</template>



<script>
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import appRouter from '@/router';
export default {
    name: 'OtpByMail',
    components: {
        BaseButtonGroup
    },
    data() {
        return {
            ddNumberField: 'ddNumber',
            myddNum: '',
            isddNumberValid: true,
        }
    },
    computed: {
        // loginType() {
        // return this.$store.state.guestLogin.loginTypeId;
        // },
        contactInfo() {
            return this.$store.state.guestLogin.loginUserDetails;
        }
    },
    created() {
        
    },

    mounted() {
        window.scroll(0,0);
        document.body.setAttribute("tabindex", "1");
        document.body.focus();

        document.body.removeAttribute("tabindex");
        document.getElementById("app").scrollTop = 0;
    },
    watch: {

    },
    methods: {
        async handleRouting(info) {
            if(info=='close') {
                appRouter.push({ path : '/guest-signin' });
            }
            // else {
            //     let payloadData = {
            //         verificationCode: this.myddNum,
            //     }
            //     await this.getGuestLogin(payloadData);
            // } 
        }
    }
}
</script>


<style lang="scss" scoped>
.user-address{
    line-height: 2rem;
    word-wrap: break-word; 
    span {
        display: block;
        line-height: 30px;
    }
}

</style>
